module.exports = __webpack_public_path__ + "static/media/TemplateBanner.807b48d7.svg";